module.exports = __webpack_public_path__ + "static/media/AzoSansBold.5643e4ee.woff";